import { useRef } from 'react'

import Button from './Button'
import { useFeedback } from '../hooks/feedback-hook'
import { useCheckBackendR } from '../hooks/utils-functions'
import {
  useAlgoritmiCheckFolderMutation,
  useAlgoritmiUploadMutation,
  useAlgoritmiRunMutation,
} from '../hooks/api-slice'

const ButtonUpload = ({
  buttonText,
  algorithm,
  fileName,
  runScript = false,
  uploadCampionato,
  uploadStagione,
}) => {
  const [triggerCheckFolder] = useAlgoritmiCheckFolderMutation()
  const [triggerUpload] = useAlgoritmiUploadMutation()
  const [triggerRun] = useAlgoritmiRunMutation()

  const uploadFileRef = useRef()

  const { setFeedback } = useFeedback()
  const { checkBackendR } = useCheckBackendR()

  const uploadFile = async (algorithm, file, fileName, runScript) => {
    if (!file) return

    if (file.type !== 'text/csv') {
      setFeedback('Il file deve essere in formato CSV.')
      return
    }

    if (!algorithm) {
      setFeedback('Algoritmo non definito.')
      return
    }

    try {
      await checkBackendR()
    } catch (err) {
      setFeedback(err.message)
      return
    }

    const formData = new FormData()
    formData.append('File', file)
    try {
      await triggerCheckFolder(algorithm).unwrap()
      await triggerUpload({ algorithm, fileName, formData }).unwrap()

      setFeedback('File caricato correttamente!', false)

      if (runScript) {
        const urlSuffix =
          (algorithm === '05_UpdateCalendari' && `/${uploadCampionato}`) ||
          (algorithm === '19_UpdateTesserati' && `/${uploadStagione}`) ||
          ''
        await triggerRun({ algorithm, urlSuffix }).unwrap()
      }
    } catch (err) {
      setFeedback(err.message || err.data?.message)
    }
    if (uploadFileRef.current) uploadFileRef.current.value = ''
  }

  return (
    <center>
      <input
        id={`upload-file-${algorithm}`}
        ref={uploadFileRef}
        type='file'
        accept='text/csv'
        style={{ display: 'none' }}
        onChange={event =>
          uploadFile(algorithm, event.target.files[0], fileName, runScript)
        }
      />
      <Button
        light
        disabled={
          (algorithm === '05_UpdateCalendari' && !uploadCampionato) ||
          (algorithm === '19_UpdateTesserati' && !uploadStagione)
        }
        onClick={() => {
          if (uploadFileRef.current) uploadFileRef.current.value = ''
          uploadFileRef.current?.click()
        }}
      >
        {buttonText}
      </Button>
    </center>
  )
}

export default ButtonUpload
